import React from "react";
import { Tooltip } from "@material-ui/core";
import classNames from "classnames"
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";

interface PropsType {
  name: string,
  checked: boolean,
  tooltip: string,
  disabled: boolean,
  checkboxClassName?: string,
  onChange: any
}

const InputCheckbox = (props: PropsType) => {
  const {
    name,
    checked,
    tooltip,
    disabled,
    checkboxClassName,
    onChange
  } = props;

  return (
    <Tooltip {...DEFAULT_TOOLTIP_PROPS}
      title={tooltip}
      placement="top"
    >
      <div className="checkbox-container">
        <input
          type="checkbox"
          className="checkbox-input d-none"
          style={disabled ? {pointerEvents: "none"} : {}}
          id={name}
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <label
          className={classNames("checkbox-label", checkboxClassName, {
            checked,
            disabled
          })}
          htmlFor={name}
        >
          <svg><use xlinkHref="#checkmark-icon" fill="#ffffff" /></svg>
        </label>
      </div>
    </Tooltip>
  );
};

export default InputCheckbox;
